import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@/components/atoms/Button';
import Heading from '@/components/atoms/Heading';
import InputFieldError from '@/components/atoms/InputFieldError';
import updateDataLayer from '@/utils/gtml';
import { validateEmail } from '@/utils/validateEmail';
import clsx from 'clsx';
import { useRef, useState } from 'react';
import { Form, Input, Label, TextField } from 'react-aria-components';
const FooterNewsletterForm = ({ title, placeholder, validationLabel, buttonLabel, endpoint, }) => {
    const emailRef = useRef(null);
    const [error, setError] = useState(false);
    const [hasTyped, setHasTyped] = useState(false);
    const handleInput = () => {
        if (!hasTyped) {
            updateDataLayer({
                event: 'newsletter',
                content_type: 'newsletter start',
            });
            setHasTyped(true);
        }
    };
    const handleSubmit = (event) => {
        const email = emailRef.current?.value;
        if (!email || !validateEmail(email)) {
            event.preventDefault();
            setError(() => true);
            return;
        }
        updateDataLayer({
            event: 'newsletter',
            content_type: 'newsletter subscribed',
            email: email,
        });
        setError(() => false);
    };
    return (_jsxs("div", { className: "flex flex-col", children: [_jsx(Heading, { className: "mb-0.75", as: "h2", variant: "ex-sm", children: title }), _jsxs(Form, { className: clsx('flex flex-col gap-0.5 lg:gap-1', error && 'lg:gap-0.5'), method: "get", action: endpoint, onSubmit: handleSubmit, validationBehavior: "aria", children: [_jsxs(TextField, { className: "flex flex-col gap-0.5", type: "email", name: "email", children: [_jsx(Label, { className: "sr-only", children: placeholder }), _jsx(Input, { ref: emailRef, className: clsx('w-full bg-surface-secondary px-1 py-0.75 text-s-body-regular text-text-body placeholder:text-text-placeholder', error ? 'border-b border-b-border-error' : 'border-b border-b-border-standard'), placeholder: placeholder, onInput: handleInput }), error && _jsx(InputFieldError, { errorMessage: validationLabel })] }), _jsx(Button, { mode: "interactive", variant: "solid", children: (buttonProps) => (_jsx("button", { ...buttonProps, type: "submit", children: buttonLabel })) })] })] }));
};
export default FooterNewsletterForm;
